// @flow

import {
    GET_PROJECT_FAILURE,
    GET_PROJECT_REQUEST,
    GET_PROJECT_SUCCESS
} from "../actions/actionTypes";

type State = {
    isFetching: boolean,
    id: ?string,
    hasDrawing: ?boolean,
};

type Action = {
    type: string,
    response: any,
};

const initialState: State = {
    isFetching: false,
    id: null,
    hasDrawing: null
};

const projectReducer = (state: State = initialState, action: Action) => {
    switch (action.type) {
        case GET_PROJECT_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_PROJECT_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                id: action.response.id,
                hasDrawing: action.response.hasDrawing
            });
        case GET_PROJECT_FAILURE:
            return initialState;
        default:
            return state;
    }
};

export default projectReducer;
